import {
  AUTH_GOOGLE_CLIENT,
  AUTH_FB_CLIENT,
  AUTH_GOOGLE_CLIENT_FAILURE,
  SIGNUP_CLIENT,
  AUTH_USER,
  SIGN_OUT_USER,
  AUTH_ERROR,
  AUTH_FORM_ABOUT,
  AUTH_FORM_TITULAR,
  PROVIDE_LAWFIRM_DATA,
  LOOK_SUCCESS,
  DELETE_PICTURE_PROFILE_SUCCESS,
  AUTH_FORM_EXPERIENCE,
  AUTH_FORM_COMMUNITY,
  RESPONSE_TIME_COMMUNITY,
  GET_RECENT_ANSWERS,
  ADD_CERTIFICATION_SUCCESS,
  EDIT_CERTIFICATION_SUCCESS,
  DELETE_CERTIFICATION_SUCCESS,
  ADD_PUBLICATION_SUCCESS,
  EDIT_PUBLICATION_SUCCESS,
  DELETE_PUBLICATION_SUCCESS,
  ADD_AWARD_SUCCESS,
  EDIT_AWARD_SUCCESS,
  DELETE_AWARD_SUCCESS,
  ADD_LABORAL_SUCCESS,
  EDIT_LABORAL_SUCCESS,
  DELETE_LABORAL_SUCCESS,
  ADD_SPECIALTY_SUCCESS,
  EDIT_SPECIALTY_SUCCESS,
  DELETE_SPECIALTY_SUCCESS,
  ADD_HOLDER_SUCCESS,
  EDIT_HOLDER_SUCCESS,
  ADD_TITULAR_PREMIUM_SUCCESS,
  DELETE_HOLDER_SUCCESS,
  ADD_LAWYER_SUCCESS,
  EDIT_LAWYER_SUCCESS,
  DELETE_LAWYER_SUCCESS,
  ADD_INFO_SUCCESS,
  ADD_SOCIAL_NETWORKS_SUCCESS,
  ADD_SEDE_SUCCESS,
  EDIT_SEDE_SUCCESS,
  DELETE_SEDE_SUCCESS,
  ADD_COST_SUCCESS,
  SCHEDULE_SAVED,
  SCHEDULE_DELETED,
  DELETE_PICTURE_SUCCESS,
  ADD_VIDEO_SUCCESS,
  DELETE_VIDEO_SUCCESS,
  UPDATE_IMG_PHOTOS,
  ADD_EDUCATION_SUCCESS,
  EDIT_EDUCATION_SUCCESS,
  DELETE_EDUCATION_SUCCESS,
  ADD_COURSES_SUCCESS,
  EDIT_COURSES_SUCCESS,
  DELETE_COURSES_SUCCESS,
  NOTIFICATION_READED,
  NOTIFICATION_DELETED,
  NOTIFICATION_RESTARTED,
  UPDATE_LAWYER_MENU_NOTIFICATION,
  UPDATE_LAWYER_PAGE_NOTIFICATION,
  UPDATE_NOTIFICATIONSLAW,
  MESSAGE_DELETED,
  MESSAGE_READED,
  MESSAGE_SAVED,
  CONTACT_DELETED,
  OPINION_DELETED,
  SET_SHARE_TROPHIE,
  ANALYTICS_MESSAGE_LOAD,
  ANALYTICS_OPINION_LOAD,
  ANALYTICS_VIEWPROFILE_LOAD,
  ANALYTICS_MAIL_LOAD,
  ANALYTICS_PHONE_LOAD,
  ANALYTICS_WEB_LOAD,
  ANALYTICS_WHATSAPP_LOAD,
  ANALYTICS_MEDIOS_LOAD,
  NOTIFICATION_PAGE_LOAD,
  NOTIFICATION_MENU_LOAD,
  AUTH_FORM_ABOUT_FIRM,
  MESSAGE_LOAD,
  OPINIONS_LOAD,
  NOTIFICATION_LOAD,
  UPDATE_CLIENT_DATA,
  UPDATE_CLIENT_DATA_SOCIAL,
  UPDATE_CLIENT_PHONE_NUMBER,
  MEMBERSHIP_DATA,
  UPDATE_MEMBERSHIP,
  ADD_NEW_CARD,
  SHOW_MODAL_NEW_TERMS,
  CHANGING_TERMS,

} from '../actions/UserAction';
import { CREATED_CARD } from '../actions/billingAction';
import { USER_STATUS } from '../../types/UserTypes';

const initialState = {
  authenticated: false,
  error: null,
  statusUser: '',
  newTermsModal: false
};

const authClient = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MODAL_NEW_TERMS:
      return {
        ...state,
        newTermsModal: action.data
      };
    case CHANGING_TERMS:
      return {
        ...state,
        termsAndConditions: action.data
      };
    case AUTH_USER:
      return {
        ...state,
        ...action.data,
        error: null,
      };
    case PROVIDE_LAWFIRM_DATA:
      return {
        ...state,
        lawFirmData: action.data
      };

    case MESSAGE_LOAD:
      return {
        ...state,
        messageLaw: action.data,
      };
    case OPINIONS_LOAD:
      return {
        ...state,
        opinionsLaw: action.data,
      };

    case NOTIFICATION_PAGE_LOAD:
      return {
        ...state,
        notificationsPageLoad: action.data,
      };
    case NOTIFICATION_LOAD:
      return {
        ...state,
        notificationsLaw: action.data,
      };
    case NOTIFICATION_MENU_LOAD:
      return {
        ...state,
        notificationsMenuLoad: action.data,
      };
    case NOTIFICATION_READED:
      return {
        ...state,
        notificationsLaw: action.data,
      };
    case MESSAGE_READED:
      return {
        ...state,
        messageLaw: action.data,
      };
    case MESSAGE_SAVED:
      return {
        ...state,
        messageLaw: action.data,
      };
    case NOTIFICATION_DELETED:
      return {
        ...state,
        notificationsLaw: action.data,
      };
    case UPDATE_LAWYER_MENU_NOTIFICATION:
      return {
        ...state,
        notificationsMenuLoad: action.data,
      };
    case UPDATE_LAWYER_PAGE_NOTIFICATION:
      return {
        ...state,
        notificationsPageLoad: {
          ...state.notificationsPageLoad,
          data: action.data
        }
      };
    case UPDATE_NOTIFICATIONSLAW:
      return {
        ...state,
        notificationsLaw: action.data,
      };
    case NOTIFICATION_RESTARTED:
      return {
        ...state,
        newNotifications: action.data,
      };
    case MESSAGE_DELETED:
      return {
        ...state,
        messageLaw: action.data,
      };
    case CONTACT_DELETED:
      return {
        ...state,
        messageLaw: action.data
    };
    // case OPINION_DELETED:
    //   console.log('action.data', action.data);
      
    //   return {
    //     ...state,
    //     opinionsLaw: action.data
    // };

    case ANALYTICS_MESSAGE_LOAD:
      return {
        ...state,
        analyticsMessage: action.data,
      };

    case ANALYTICS_OPINION_LOAD:
      return {
        ...state,
        analyticsOpinion: action.data,
      };

    case ANALYTICS_VIEWPROFILE_LOAD:
      return {
        ...state,
        analyticsViewProfile: action.data,
      };

    case ANALYTICS_MAIL_LOAD:
      return {
        ...state,
        analyticsMail: action.data,
      };

    case ANALYTICS_PHONE_LOAD:
      return {
        ...state,
        analyticsPhone: action.data,
      };

    case ANALYTICS_WEB_LOAD:
      return {
        ...state,
        analyticsWeb: action.data,
      };
    case ANALYTICS_WHATSAPP_LOAD:
      return {
        ...state,
        analyticsWhatsapp: action.data,
      };
    case ANALYTICS_MEDIOS_LOAD:
      return {
        ...state,
        analyticsMedios: action.data,
      };

    case UPDATE_IMG_PHOTOS:
      return {
        ...state,
        imgViews: action.data,
        awardAditional: {
          cost: state.awardAditional.cost,
          pictures: action.boolValues,
          videos: state.awardAditional.videos,
          shareProfile: state.awardAditional.shareProfile,
          highQualification: state.awardAditional.highQualification,
          coursesLawyer: state.awardAditional.coursesLawyer,
        },
      };

    case UPDATE_CLIENT_DATA:
      return {
        ...state,
        name: action.data.name,
        lastName: action.data.lastName,
      };

    case UPDATE_CLIENT_DATA_SOCIAL:
      return {
        ...state,
        displayName: action.data.displayName,
        name: action.data.name,
        lastName: action.data.lastName,
      };

    case UPDATE_CLIENT_PHONE_NUMBER:
      return {
        ...state,
        phone: action.data,
      };

    case SIGN_OUT_USER:
      return {
        authenticated: false,
        error: null,
      };
    case LOOK_SUCCESS:
      return {
        ...state,
        ...action.data,
        awardPerfil: {
          look: action.data.awardPerfil.look,
          about: state.awardPerfil.about,
          contact: state.awardPerfil.contact,
          socialNetworks: state.awardPerfil.socialNetworks,
          experience: state.awardPerfil.experience,
          site: state.awardPerfil.site,
          collaborators: state.awardPerfil.collaborators
            ? state.awardPerfil.collaborators
            : null,
          holder: state.awardPerfil.holder ? state.awardPerfil.holder : null,
        },
      };

    case DELETE_PICTURE_PROFILE_SUCCESS:
      return {
        ...state,
        imgProfile: action.data,
        awardPerfil: {
          ...state.awardPerfil,
          look: action.boolValues,
        },
      };

    case ADD_CERTIFICATION_SUCCESS:
      return {
        ...state,
        certificationsLawyer: action.data,
        awardPerfil: {
          ...state.awardPerfil,
          certificationsLawyer: action.boolValues,
        },
      };

    case EDIT_CERTIFICATION_SUCCESS:
      return {
        ...state,
        certificationsLawyer: action.data,
        awardPerfil: {
          ...state.awardPerfil,
          certificationsLawyer: action.boolValues,
        },
      };

    case DELETE_CERTIFICATION_SUCCESS:
      return {
        ...state,
        certificationsLawyer: action.data,
        awardPerfil: {
          ...state.awardPerfil,
          certificationsLawyer: action.boolValues,
        },
      };

    case ADD_PUBLICATION_SUCCESS:
      return {
        ...state,
        publicationsLawyer: action.data,
        awardPerfil: {
          ...state.awardPerfil,
          publicationsLawyer: action.boolValues,
        },
      };

    case EDIT_PUBLICATION_SUCCESS:
      return {
        ...state,
        publicationsLawyer: action.data,
        awardPerfil: {
          ...state.awardPerfil,
          publicationsLawyer: action.boolValues,
        },
      };

    case DELETE_PUBLICATION_SUCCESS:
      return {
        ...state,
        publicationsLawyer: action.data,
        awardPerfil: {
          ...state.awardPerfil,
          publicationsLawyer: action.boolValues,
        },
      };

    case ADD_AWARD_SUCCESS:
      return {
        ...state,
        awardsLawyer: action.data,
        awardPerfil: {
          ...state.awardPerfil,
          awardsLawyer: action.boolValues,
        },
      };

    case EDIT_AWARD_SUCCESS:
      return {
        ...state,
        awardsLawyer: action.data,
        awardPerfil: {
          ...state.awardPerfil,
          awardsLawyer: action.boolValues,
        },
      };

    case DELETE_AWARD_SUCCESS:
      return {
        ...state,
        awardsLawyer: action.data,
        awardPerfil: {
          ...state.awardPerfil,
          awardsLawyer: action.boolValues,
        },
      };

    case ADD_LABORAL_SUCCESS:
      return {
        ...state,
        laboralsLawyer: action.data,
        awardPerfil: {
          ...state.awardPerfil,
          laboralsLawyer: action.boolValues,
        },
      };

    case EDIT_LABORAL_SUCCESS:
      return {
        ...state,
        laboralsLawyer: action.data,
        awardPerfil: {
          ...state.awardPerfil,
          laboralsLawyer: action.boolValues,
        },
      };

    case DELETE_LABORAL_SUCCESS:
      return {
        ...state,
        laboralsLawyer: action.data,
        awardPerfil: {
          ...state.awardPerfil,
          laboralsLawyer: action.boolValues,
        },
      };

    case ADD_SPECIALTY_SUCCESS:
      return {
        ...state,
        specialties: action.data.spe,
        subSpecialities: action.data.sub,
        extraSubSpecialities: action.data.extra,
        awardPerfil: {
          ...state.awardPerfil,
          specialties: action.boolValues,
        },
      };

    case EDIT_SPECIALTY_SUCCESS:
      return {
        ...state,
        specialties: action.data.spe,
        subSpecialities: action.data.sub,
        extraSubSpecialities: action.data.extra,
        awardPerfil: {
          ...state.awardPerfil,
          specialties: action.boolValues,
        },
      };

    case DELETE_SPECIALTY_SUCCESS:
      return {
        ...state,
        specialties: action.data.spe,
        subSpecialities: action.data.sub,
        extraSubSpecialities: action.data.extra,
        awardPerfil: {
          ...state.awardPerfil,
          specialties: action.boolValues,
        },
      };

    case ADD_HOLDER_SUCCESS:
      return {
        ...state,
        holders: action.data,
        awardPerfil: {
          look: state.awardPerfil.look,
          about: state.awardPerfil.about,
          experience: state.awardPerfil.experience,
          contact: state.awardPerfil.contact,
          socialNetworks: state.awardPerfil.socialNetworks,
          collaborators: state.awardPerfil.collaborators,
          holder: action.boolValues,
          site: state.awardPerfil.site,
        },
      };

    case EDIT_HOLDER_SUCCESS:
      return {
        ...state,
        holders: action.data,
        awardPerfil: {
          about: state.awardPerfil.about,
          contact: state.awardPerfil.contact,
          experience: state.awardPerfil.experience,
          look: state.awardPerfil.look,
          socialNetworks: state.awardPerfil.socialNetworks,
          collaborators: state.awardPerfil.collaborators,
          holder: action.boolValues,
          site: state.awardPerfil.site,
        },
      };

      case ADD_TITULAR_PREMIUM_SUCCESS:
        console.log(action)
        return {
          ...state,
          holders: action.data,
          credentialsLawyer:{
            email:action.info.email,
            password:action.info.password,
            uidLawyer:action.info.uid
          }
        };

    case DELETE_HOLDER_SUCCESS:
      return {
        ...state,
        holders: action.data,
        awardPerfil: {
          about: state.awardPerfil.about,
          contact: state.awardPerfil.contact,
          experience: state.awardPerfil.experience,
          look: state.awardPerfil.look,
          socialNetworks: state.awardPerfil.socialNetworks,
          collaborators: state.awardPerfil.collaborators,
          holder: action.boolValues,
          site: state.awardPerfil.site,
        },
      };

    case ADD_LAWYER_SUCCESS:
      return {
        ...state,
        lawyers: action.data,
        awardPerfil: {
          look: state.awardPerfil.look,
          about: state.awardPerfil.about,
          experience: state.awardPerfil.experience,
          contact: state.awardPerfil.contact,
          socialNetworks: state.awardPerfil.socialNetworks,
          collaborators: action.boolValues,
          holder: state.awardPerfil.holder,
          site: state.awardPerfil.site,
        },
      };

    case EDIT_LAWYER_SUCCESS:
      return {
        ...state,
        lawyers: action.data,
        awardPerfil: {
          about: state.awardPerfil.about,
          contact: state.awardPerfil.contact,
          experience: state.awardPerfil.experience,
          look: state.awardPerfil.look,
          socialNetworks: state.awardPerfil.socialNetworks,
          collaborators: action.boolValues,
          holder: state.awardPerfil.holder,
          site: state.awardPerfil.site,
        },
      };

    case DELETE_LAWYER_SUCCESS:
      return {
        ...state,
        lawyers: action.data,
        awardPerfil: {
          about: state.awardPerfil.about,
          contact: state.awardPerfil.contact,
          experience: state.awardPerfil.experience,
          look: state.awardPerfil.look,
          socialNetworks: state.awardPerfil.socialNetworks,
          collaborators: action.boolValues,
          holder: state.awardPerfil.holder,
          site: state.awardPerfil.site,
        },
      };

    case DELETE_PICTURE_SUCCESS:
      return {
        ...state,
        imgViews: action.data,
        awardAditional: {
          cost: state.awardAditional.cost,
          pictures: action.boolValues,
          videos: state.awardAditional.videos,
          shareProfile: state.awardAditional.shareProfile,
          highQualification: state.awardAditional.highQualification,
          coursesLawyer: state.awardAditional.coursesLawyer,
        },
      };

    case ADD_VIDEO_SUCCESS:
      return {
        ...state,
        videosYoutube: [{ ...action.data }],
        awardAditional: {
          videos: action.boolValues,
          cost: state.awardAditional.cost,
          pictures: state.awardAditional.pictures,
          shareProfile: state.awardAditional.shareProfile,
          highQualification: state.awardAditional.highQualification,
          coursesLawyer: state.awardAditional.coursesLawyer,
        },
      };

    case DELETE_VIDEO_SUCCESS:
      return {
        ...state,
        videosYoutube: action.data,
        awardAditional: {
          videos: action.boolValues,
          cost: state.awardAditional.cost,
          pictures: state.awardAditional.pictures,
          shareProfile: state.awardAditional.shareProfile,
          coursesLawyer: state.awardAditional.coursesLawyer,
          highQualification: state.awardAditional.highQualification,
        },
      };

    case ADD_INFO_SUCCESS:
      return {
        ...state,
        contacto: { ...action.data },
        awardPerfil: {
          look: state.awardPerfil.look,
          about: state.awardPerfil.about,
          experience: state.awardPerfil.experience,
          contact: action.boolValues,
          socialNetworks: state.awardPerfil.socialNetworks,
          site: state.awardPerfil.site,
          collaborators: state.awardPerfil.collaborators
            ? state.awardPerfil.collaborators
            : null,
          holder: state.awardPerfil.holder ? state.awardPerfil.holder : null,
        },
      };

    case ADD_SOCIAL_NETWORKS_SUCCESS:
      return {
        ...state,
        socialNetworks: { ...action.data },
        awardPerfil: {
          ...state.awardPerfil,
          socialNetworks: action.boolValues,
        },
      };

    case ADD_SEDE_SUCCESS:
      return {
        ...state,
        sede: action.data,
        awardPerfil: {
          look: state.awardPerfil.look,
          about: state.awardPerfil.about,
          experience: state.awardPerfil.experience,
          contact: state.awardPerfil.contact,
          socialNetworks: state.awardPerfil.socialNetworks,
          site: action.boolValues,
          collaborators: state.awardPerfil.collaborators
            ? state.awardPerfil.collaborators
            : null,
          holder: state.awardPerfil.holder ? state.awardPerfil.holder : null,
        },
      };

    case EDIT_SEDE_SUCCESS:
      return {
        ...state,
        sede: action.data,
        awardPerfil: {
          look: state.awardPerfil.look,
          about: state.awardPerfil.about,
          experience: state.awardPerfil.experience,
          contact: state.awardPerfil.contact,
          socialNetworks: state.awardPerfil.socialNetworks,
          site: action.boolValues,
          collaborators: state.awardPerfil.collaborators
            ? state.awardPerfil.collaborators
            : null,
          holder: state.awardPerfil.holder ? state.awardPerfil.holder : null,
        },
      };

    case DELETE_SEDE_SUCCESS:
      return {
        ...state,
        sede: action.data,
        awardPerfil: {
          look: state.awardPerfil.look,
          about: state.awardPerfil.about,
          experience: state.awardPerfil.experience,
          contact: state.awardPerfil.contact,
          socialNetworks: state.awardPerfil.socialNetworks,
          site: action.boolValues,
          collaborators: state.awardPerfil.collaborators
            ? state.awardPerfil.collaborators
            : null,
          holder: state.awardPerfil.holder ? state.awardPerfil.holder : null,
        },
      };

    case SCHEDULE_SAVED:
      return {
        ...state,
        schedule: {
          type: action.typeSchedule,
          scheduleDays: action.data,
        },
        awardPerfil: {
          look: state.awardPerfil.look,
          about: state.awardPerfil.look,
          schedule: action.boolValues,
          experience: state.awardPerfil.experience,
          contact: state.awardPerfil.contact,
          socialNetworks: state.awardPerfil.socialNetworks,
          holder: state.awardPerfil.holder,
          collaborators: state.awardPerfil.collaborators,
          site: state.awardPerfil.site,
        },
      };

    case SCHEDULE_DELETED:
      return {
        ...state,
        schedule: action.data,
        awardPerfil: {
          look: state.awardPerfil.look,
          about: state.awardPerfil.look,
          schedule: action.boolValues,
          experience: state.awardPerfil.experience,
          contact: state.awardPerfil.contact,
          socialNetworks: state.awardPerfil.socialNetworks,
          holder: state.awardPerfil.holder,
          collaborators: state.awardPerfil.collaborators,
          site: state.awardPerfil.site,
        },
      };

    case ADD_COST_SUCCESS:
      return {
        ...state,
        cost: { ...action.data },
        awardAditional: {
          cost: action.boolValues,
          pictures: state.awardAditional.pictures,
          videos: state.awardAditional.videos,
          shareProfile: state.awardAditional.shareProfile,
          coursesLawyer: state.awardAditional.coursesLawyer,
          highQualification: state.awardAditional.highQualification,
        },
      };

    case ADD_EDUCATION_SUCCESS:
      return {
        ...state,
        educationLawyer: action.data,
        awardPerfil: {
          ...state.awardPerfil,
          educationLawyer: action.boolValues,
        },
      };

    case EDIT_EDUCATION_SUCCESS:
      return {
        ...state,
        educationLawyer: action.data,
        awardPerfil: {
          ...state.awardPerfil,
          educationLawyer: action.boolValues,
        },
      };

    case DELETE_EDUCATION_SUCCESS:
      return {
        ...state,
        educationLawyer: action.data,
        awardPerfil: {
          ...state.awardPerfil,
          educationLawyer: action.boolValues,
        },
      };

    case ADD_COURSES_SUCCESS:
      return {
        ...state,
        coursesLawyer: action.data,
        awardAditional: {
          ...state.awardAditional,
          coursesLawyer: action.boolValues,
        },
      };

    case EDIT_COURSES_SUCCESS:
      return {
        ...state,
        coursesLawyer: action.data,
        awardAditional: {
          ...state.awardAditional,
          coursesLawyer: action.boolValues,
        },
      };

    case DELETE_COURSES_SUCCESS:
      return {
        ...state,
        coursesLawyer: action.data,
        awardAditional: {
          ...state.awardAditional,
          coursesLawyer: action.boolValues,
        },
      };

    case SET_SHARE_TROPHIE: {
      return {
        ...state,
        awardAditional: {
          cost: state.awardAditional.cost,
          coursesLawyer: state.awardAditional.coursesLawyer,
          pictures: state.awardAditional.pictures,
          videos: state.awardAditional.videos,
          shareProfile: action.data,
          highQualification: state.awardAditional.highQualification,
        },
      };
    }

    case UPDATE_MEMBERSHIP: {
      return {
        ...state,
        membership: { ...action.data },
      };
    }

    case CREATED_CARD: {
      return {
        ...state,
        membershipData: {
          cards: [...state.membershipData.cards, action.data],
        },
      };
    }

    case AUTH_ERROR:
      return {
        ...state,
        authenticated: false,
        error: action.payload.message,
      };
    case AUTH_GOOGLE_CLIENT:
      return {
        ...state,
        status: action.payload,
      };
    case AUTH_FORM_ABOUT:
      return {
        ...state,
        name: action.data.name,
        firstLastName: action.data.firstLastName,
        secondLastName: action.data.secondLastName,
        // specialties: action.data.specialties,
        gradeStudy: action.data.gradeStudy,
        cedula: action.data.cedula,
        expYears: action.data.expYears,
        colegNumber: action.data.colegNumber,
        languages: action.data.languages,
        awardPerfil: {
          look: state.awardPerfil.look,
          about: action.boolValues,
          experience: state.awardPerfil.experience,
          contact: state.awardPerfil.contact,
          socialNetworks: state.awardPerfil.socialNetworks,
          site: state.awardPerfil.site,
        },
      };
    case AUTH_FORM_ABOUT_FIRM:
      return {
        ...state,
        // specialties: action.data.specialties,
        expYears: action.data.expYears,
        phone: action.data.phone,
        officeName: action.data.officeName,
        awardPerfil: {
          look: state.awardPerfil.look,
          about: action.boolValues,
          experience: state.awardPerfil.experience,
          contact: state.awardPerfil.contact,
          socialNetworks: state.awardPerfil.socialNetworks,
          holder: state.awardPerfil.holder,
          collaborators: state.awardPerfil.collaborators,
          site: state.awardPerfil.site,
        },
      };
    case AUTH_FORM_TITULAR:
      return {
        ...state,
        name: action.data.name,
        firstLastName: action.data.firstLastName,
        secondLastName: action.data.secondLastName,
        specialtiesTitular: action.data.specialtiesTitular,
        cedula: action.data.cedula,
        awards: action.data.awards,
        nameUniversity: action.data.nameUniversity,
        experience: action.data.experience,
        awardPerfil: {
          look: state.awardPerfil.look,
          about: state.awardPerfil.about,
          experience: state.awardPerfil.experience,
          contact: state.awardPerfil.contact,
          socialNetworks: state.awardPerfil.socialNetworks,
          holder: action.boolValues,
          collaborators: state.awardPerfil.collaborators,
          site: state.awardPerfil.site,
        },
      };
    case AUTH_FORM_EXPERIENCE:
      return {
        ...state,
        experience: action.data,
        awardPerfil: {
          look: state.awardPerfil.look,
          about: action.boolValues,
          experience: action.boolValues,
          contact: state.awardPerfil.contact,
          socialNetworks: state.awardPerfil.socialNetworks,
          holder: state.awardPerfil.holder,
          collaborators: state.awardPerfil.collaborators,
          site: state.awardPerfil.site,
        },
      };
    case AUTH_FORM_COMMUNITY:
      return {
        ...state,
        community: action.data,
        awardPerfil: {
          community: action.data,
          look: state.awardPerfil.look,
          about: state.boolValues,
          experience: state.boolValues,
          contact: state.awardPerfil.contact,
          holder: state.awardPerfil.holder,
          collaborators: state.awardPerfil.collaborators,
          site: state.awardPerfil.site,
        },
      };
    case RESPONSE_TIME_COMMUNITY:
      return {
        ...state,
        responseTime: action.data,
      };
    case GET_RECENT_ANSWERS:
      return {
        ...state,
        recentAnswers: action.data,
      };
    case AUTH_FB_CLIENT:
      return {
        ...state,
        status: action.payload,
      };
    case AUTH_GOOGLE_CLIENT_FAILURE:
      return {
        ...state,
        signUpGoogleError: true,
      };
    case SIGNUP_CLIENT:
      return action.payload;
    case 'LOAD_FILE':
      return {
        ...state,
        status: action.payload,
      };
    case 'LOAD_ARRAY_FILE':
      return {
        ...state,
        status: action.payload,
      };


    case ADD_NEW_CARD:
      return {
        ...state,
        membershipData: {
          cards: [...state.membershipData.cards, action.data],
        },
      };

    case MEMBERSHIP_DATA:
      return {
        ...state,
        membershipData: {
          idStripe:action.data.idStripe,
          idFacturapi: action.data.idFacturapi,
          payments: action.data.payments,
          cards: action.data.cards,
          invoices: action.data.invoices,
        },
      };


    case 'UPDATE_QUALIFICATION':
      return {
        ...state,
        awardAditional: {
          cost: state.awardAditional.cost,
          pictures: state.awardAditional.pictures,
          videos: state.awardAditional.videos,
          shareProfile: state.awardAditional.shareProfile,
          coursesLawyer: state.awardAditional.coursesLawyer,
          highQualification: action.data,
        },
      };

    default:
      return state;
  }
};

export default authClient;
